const cardStyles = [
  'bg-gradient-to-br from-[#1a1a2e] via-[#16213e] to-[#0f3460]',   // deep navy
  'bg-gradient-to-br from-[#1a2e1a] via-[#163e2a] to-[#0f4030]',   // deep forest green
  'bg-gradient-to-br from-[#2e1a1a] via-[#3e1616] to-[#4a0f0f]',   // deep crimson
  'bg-gradient-to-br from-[#2e2a1a] via-[#3e3416] to-[#4a3a0f]',   // deep amber
  'bg-gradient-to-br from-[#1a2e2e] via-[#163e3e] to-[#0f4040]',   // deep teal
  'bg-gradient-to-br from-[#2a1a2e] via-[#34163e] to-[#3a0f4a]',   // deep violet
  'bg-gradient-to-br from-[#1a2a2e] via-[#16303e] to-[#0f3a4a]',   // deep ocean
  'bg-gradient-to-br from-[#2e1a2a] via-[#3e1634] to-[#4a0f3a]',   // deep rose
];

const glowColors = [
  'bg-[#2C2CE8]/20',
  'bg-[#2CE87b]/20',
  'bg-[#E82C2C]/20',
  'bg-[#E8A02C]/20',
  'bg-[#2CE8E8]/20',
  'bg-[#9B2CE8]/20',
  'bg-[#2C9BE8]/20',
  'bg-[#E82C9B]/20',
];

export default function TeamSection() {
  const teamMembers = [
    {
      name: 'Sofia Naumovski',
      role: 'Founder & CEO',
      image: 'https://static.readdy.ai/image/fd7fa72396c6d37ebdaed119979e020e/ddd42470bcdb54bc87841b40c4c04f9d.jfif',
      linkedin: 'https://www.linkedin.com/in/sofia-naumovski/'
    },
    {
      name: 'Swathi Annamalai',
      role: 'Head of Product',
      image: 'https://static.readdy.ai/image/fd7fa72396c6d37ebdaed119979e020e/5ae8ed9283a66a8ea59baacbd2e97c51.png',
      linkedin: 'https://www.linkedin.com/in/swathi54/'
    },
    {
      name: 'Ryan Rudolph',
      role: 'Aviation S&O Advisor',
      image: 'https://static.readdy.ai/image/fd7fa72396c6d37ebdaed119979e020e/eeac8431ba4828e126a683b992d6c0c6.png',
      linkedin: 'https://www.linkedin.com/in/ryan-rudolph/'
    },
    {
      name: 'Pete DuBeau',
      role: 'AI Platform Engineer',
      image: 'https://static.readdy.ai/image/fd7fa72396c6d37ebdaed119979e020e/93c87cabdf857591e0a3c1399e602386.png',
      linkedin: 'https://www.linkedin.com/in/peterdubeau/'
    },
    {
      name: 'Theo Soneriu',
      role: 'Senior Analytics Engineer',
      image: 'https://static.readdy.ai/image/fd7fa72396c6d37ebdaed119979e020e/0364afbf428c3486e06c79789b48b7f0.png',
      linkedin: 'https://www.linkedin.com/in/theodor-soneriu-9a49a67a/'
    },
    {
      name: 'Akhil Akula',
      role: 'Data Scientist',
      image: 'https://static.readdy.ai/image/fd7fa72396c6d37ebdaed119979e020e/f809ebf225a377404cf450d3ca807fa2.png',
      linkedin: 'https://www.linkedin.com/in/akhilesh-akula/'
    },
    {
      name: 'Andrew Lee',
      role: 'Software Engineer Intern',
      image: 'https://static.readdy.ai/image/fd7fa72396c6d37ebdaed119979e020e/f225e58d37232545e8881d4fedb893a9.png',
      linkedin: 'https://www.linkedin.com/in/al627/'
    },
    {
      name: 'Ashley Lee',
      role: 'Software Engineer Intern',
      image: 'https://static.readdy.ai/image/fd7fa72396c6d37ebdaed119979e020e/09a932eed59ed55dc5b6cb958f372688.png',
      linkedin: 'https://www.linkedin.com/in/ashl3yl/'
    }
  ];

  return (
    <section id="team" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Building Smarter Travel 
            <span className="text-[#2C2CE8] font-bold"> Together</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From Bark Air, ETS, Mynd & Zinnia— we are innovative leaders pioneering the next era of AI-driven travel tech.
          </p>
        </div>

        {/* Row 1 — 3 members */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {teamMembers.slice(0, 3).map((member, index) => (
            <MemberCard key={index} member={member} cardStyle={cardStyles[index]} glowColor={glowColors[index]} />
          ))}
        </div>

        {/* Row 2 — 3 members */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {teamMembers.slice(3, 6).map((member, index) => (
            <MemberCard key={index + 3} member={member} cardStyle={cardStyles[index + 3]} glowColor={glowColors[index + 3]} />
          ))}
        </div>

        {/* Row 3 — 2 members centered */}
        <div className="flex justify-center gap-8">
          {teamMembers.slice(6, 8).map((member, index) => (
            <div key={index + 6} className="w-full max-w-sm">
              <MemberCard member={member} cardStyle={cardStyles[index + 6]} glowColor={glowColors[index + 6]} />
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

function MemberCard({ member, cardStyle, glowColor }: { member: { name: string; role: string; image?: string; placeholder?: string; linkedin?: string }; cardStyle: string; glowColor: string }) {
  return (
    <div className="relative bg-white rounded-2xl p-8 shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 border border-gray-100 overflow-hidden">
      {/* Subtle glow accent */}
      <div className="absolute top-0 right-0 w-32 h-32 bg-[#2C2CE8]/10 rounded-full blur-2xl -translate-y-8 translate-x-8 pointer-events-none" />
      <div className="text-center relative z-10">
        {member.placeholder ? (
          <div className="w-24 h-24 rounded-full mx-auto mb-4 bg-[#2C2CE8] flex items-center justify-center ring-4 ring-[#2C2CE8]/20">
            <span className="text-4xl font-bold text-white">{member.placeholder}</span>
          </div>
        ) : (
          <img
            src={member.image}
            alt={member.name}
            className={`w-24 h-24 rounded-full mx-auto mb-4 object-cover ring-4 ring-[#2C2CE8]/20 ${
              member.name === 'Pete DuBeau'
                ? 'object-[center_20%]'
                : member.name === 'Swathi Annamalai'
                ? 'object-center'
                : 'object-top'
            }`}
          />
        )}
        <h3 className="text-xl font-bold text-gray-900 mb-2">{member.name}</h3>
        <p className="text-lg font-semibold mb-6 text-[#2C2CE8]">{member.role}</p>
        {member.linkedin ? (
          <a
            href={member.linkedin}
            className="w-10 h-10 flex items-center justify-center rounded-full border-2 border-[#2C2CE8]/30 hover:border-[#2C2CE8] hover:bg-[#2C2CE8]/10 transition-colors cursor-pointer mx-auto"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="ri-linkedin-fill text-lg text-[#2C2CE8]"></i>
          </a>
        ) : (
          <div className="w-10 h-10 flex items-center justify-center rounded-full border-2 border-[#2C2CE8]/30 mx-auto">
            <i className="ri-linkedin-fill text-lg text-[#2C2CE8]"></i>
          </div>
        )}
      </div>
    </div>
  );
}